import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Map.css';

const Map: React.FC = () => {
  return (
    <div className="map-container">
      <h2 className="map-title">Map of Aaron Glen</h2>
      <p className="map-instructions">
        <a href="https://what3words.com/duty.glades.valued" target="_blank" rel="noopener noreferrer">
          What Three Words: ///duty.glades.valued
        </a>
      </p>
      <div className="map-images">
        <iframe
          title="Google Maps - Aaron Glen Apartments location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2234.6504900120357!2d-3.171477!3d55.8748357!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4887bf5f83ea96d3%3A0xd0620c5d8ef49d8!2sAaron%20Glen%20Apartments!5e0!3m2!1sen!2suk!4v1620000000000!5m2!1sen!2suk"
          width="100%"
          height="450"
          style={{ border: 0, maxWidth: '100%' }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="map-image map-iframe"
        />
      </div>
    </div>
  );
};

export default Map; 